/* eslint-disable @typescript-eslint/no-explicit-any */
import { modals } from "@mantine/modals";
import { toast } from "react-hot-toast";

import { isFunction, isObject, isOpenConfirmModal, isPromise } from "./guards.http";
import type { ExtraOptions } from "./types.http";

export async function handleConfirmModal(extraOptions: ExtraOptions | undefined) {
  if (!extraOptions?.confirmModal?.enabled) return;
  const { modal } = extraOptions.confirmModal;

  if (isFunction(modal)) {
    try {
      await modal({ modal: modals });
    } catch (error) {
      return {
        error: {
          status: "CUSTOM_ERROR" as const,
          error: "Request cancelled by user",
          data: error
        }
      };
    }
    return;
  }

  if (isOpenConfirmModal(modal)) {
    try {
      let isConfirmed = false;
      await new Promise<void>((resolve, reject) => {
        modals.openConfirmModal({
          ...modal,
          onConfirm: () => {
            isConfirmed = true;
            modal.onConfirm?.();
            resolve();
          },
          onCancel: () => {
            modal.onCancel?.();
            reject(new Error("Request cancelled by user"));
          },
          onClose: () => {
            modal.onClose?.();
            if (!isConfirmed) {
              reject(new Error("Request cancelled by user"));
            }
          }
        });
      });
    } catch (error) {
      return {
        error: {
          status: "CUSTOM_ERROR" as const,
          error: "Request cancelled by user",
          data: error
        }
      };
    }
  }
}

export function handleToast(extraOptions: ExtraOptions | undefined, promise: Promise<unknown>) {
  if (!extraOptions?.toaster?.enabled) return;
  const { options, toast: toastFn } = extraOptions.toaster;

  if (!isPromise(promise)) return;

  const wrappedPromise = promise.then((response: any) => {
    if (response?.error) {
      throw response.error;
    }
    return response;
  });

  if (isFunction(toastFn)) {
    toastFn({
      toaster: toast,
      promise: wrappedPromise,
      options
    });
    return;
  }

  if (isObject(toastFn)) {
    toast.promise(wrappedPromise, toastFn, options);
  }
}
